module.exports = __webpack_public_path__ + "static/carbon-tooltip-position-8509d329c18ca7c7d9f782982965769e.png";